var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"vue-button",class:[
        _vm.type ? 'vue-button--' + _vm.type : '',
        _vm.size ? 'vue-button--' + _vm.size : '',
        _vm.disabled ? 'vue-button--disabled' : '',
        _vm.loading ? 'vue-button--loading' : ''
    ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('i'):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-090f7de2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/button.vue
// module id = null
// module chunks = 